/**
 * Polyfills for weak browsers.
 */
import 'core-js/fn/array/find';
import 'core-js/es6/map';
import 'core-js/es6/set';



// WEBPACK FOOTER //
// ./src/polyfills.js